import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateLayerRequest,
} from '../layer.actions'
import { getCreateLayerState } from '../layer.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-create-layer',
  templateUrl: './create-layer.component.html',
  styleUrls: ['./create-layer.component.css'],
})
export class CreateLayerComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createLayer'))
    this.state$ = this.store
      .pipe(select(getCreateLayerState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        e?.target ? e.target.value : e,
        'createLayer.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createLayer',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      calculation: 'required',
      delivery: 'required',
      name: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public toggle(name: string, e: any) {
    this.store.dispatch(
      new UpdateField(name, e.target.checked, 'createLayer.data'),
    )
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateLayerRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createLayer',
        ),
      )
    }
  }
}
